export class ActionCable {
  public static URL: string
}
